module.exports = __webpack_public_path__ + "img/social-proof.c2b86ad3.png";